/**
 * @generated SignedSource<<f4ce5ba6ef6c7c852ace100e30414c47>>
 * @relayHash 39ab72e4ebb13bd0b635f701a2979e96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd10fa25885e26d93d19576869d64459a7f52bb8aebc53957cc93f37270da04b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FiltersMenuContentQuery$variables = {
  first?: number | null | undefined;
  includeProjectClause?: boolean | null | undefined;
  projectId: string;
};
export type FiltersMenuContentQuery$data = {
  readonly jira: {
    readonly jiraProject: {
      readonly id: string;
      readonly key: string;
    };
    readonly jwmFilters: {
      readonly __typename: "JiraWorkManagementFilterConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly jql: string;
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"SavedFilterMenuItem_filter">;
        };
      } | null | undefined>;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type FiltersMenuContentQuery = {
  response: FiltersMenuContentQuery$data;
  variables: FiltersMenuContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeProjectClause"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "contextId",
        "variableName": "projectId"
      }
    ],
    "kind": "ObjectValue",
    "name": "searchParameters"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "args": [
    {
      "kind": "Variable",
      "name": "includeProjectClause",
      "variableName": "includeProjectClause"
    }
  ],
  "kind": "ScalarField",
  "name": "jql"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "key"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "jwmFilters",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v4/*: any*/),
                    "action": "THROW",
                    "path": "jira.jwmFilters.__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "PageInfo",
                          "kind": "LinkedField",
                          "name": "pageInfo",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v5/*: any*/),
                              "action": "THROW",
                              "path": "jira.jwmFilters.pageInfo.hasNextPage"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.jwmFilters.pageInfo"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraWorkManagementFilterEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraWorkManagementFilter",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "FragmentSpread",
                                    "name": "SavedFilterMenuItem_filter"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v6/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.id"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v7/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.name"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v8/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.jql"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.jwmFilters.edges.node"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.jwmFilters.edges"
                      }
                    ],
                    "type": "JiraWorkManagementFilterConnection"
                  },
                  (v9/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.jwmFilters"
            },
            {
              "kind": "RequiredField",
              "field": {
                "args": (v10/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProject",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v6/*: any*/),
                    "action": "THROW",
                    "path": "jira.jiraProject.id"
                  },
                  {
                    "kind": "RequiredField",
                    "field": (v11/*: any*/),
                    "action": "THROW",
                    "path": "jira.jiraProject.key"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProject"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "jwmFilters",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "JiraWorkManagementFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraWorkManagementFilter",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isEditable"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraWorkManagementFilterConnection"
              },
              (v9/*: any*/)
            ]
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v11/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bd10fa25885e26d93d19576869d64459a7f52bb8aebc53957cc93f37270da04b",
    "metadata": {},
    "name": "FiltersMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "735d2244b9e34fe75b6a8fd949f297c2";

export default node;
